"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwilioIdentity = void 0;
var TwilioIdentity;
(function (TwilioIdentity) {
    TwilioIdentity["Clinic"] = "clinic";
    TwilioIdentity["System"] = "system";
    TwilioIdentity["AutoResponse"] = "auto-response";
})(TwilioIdentity = exports.TwilioIdentity || (exports.TwilioIdentity = {}));
//# sourceMappingURL=TwilioIdentity.js.map